import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ABaseTreeNode } from '../../../../components/common/basetreecontrol/base.tree.control';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { DataModelService, DataSourceQuery } from '../../../../services/datamodel.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { DataCheck, FormulaWorkflowDialogContent } from '../../../../workflow/workflow.dialog';

@Component({
    selector: 'wf-save-resource-settings-item',
    templateUrl: 'save.resource.settings.html'
})
export class SaveResourceSettings extends FormulaWorkflowDialogContent {
    Data = new SaveResourceSettingsData();
    DataModels = [];
    DataSources = [];
    VariableNodes = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'saveResourceWFModule';
        reg.Caption = '@@Resource speichern';
        reg.GroupID = 'fileoperations';
        reg.Index = 10;
        reg.SettingsControl = SaveResourceSettings;
        reg.SettingsTypeHelper = new SaveResourceSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: DataModelService, private translate: TranslateService) {
        super();
    }

    initialize(data: any) {
        super.initialize(data);
        let index = 0;
        const varNodes = [];
        this.Variables.forEach(x => {
            const btn = new ABaseTreeNode(index++);
            btn.Caption = x.Name;
            varNodes.push(btn);
        });
        this.VariableNodes = varNodes;
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, SaveResourceSettingsData);
        }
        this.service.GetModels().subscribe(x => {
            if (x) {
                this.DataModels = x;
            }
            if (this.Data.DataModelID) {
                if (this.DataModels.some(y => y.SID === this.Data.DataModelID)) {
                    this.loadDataSources();
                } else {
                    this.Data.DataModelID = null;
                    this.Data.DataSource = null;
                }
            }
        });
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        const errors = [];
        if (!this.Data.DataSource) {
            errors.push(this.translate.instant('@@Bitte setzen Sie eine Datenquelle'));
        }
        if (!this.Data.FileName) {
            errors.push(this.translate.instant('@@Bitte vergeben Sie einen Dateinamen'));
        }
        if (!this.Data.Value) {
            switch (this.Data.ResourceType) {
                case ResourceType.Bytes:
                    errors.push(this.translate.instant('@@Bitte setzen Sie einen Status Key'));
                    break;
                case ResourceType.Text:
                    if (this.Data.GetFromStatus) {
                        errors.push(this.translate.instant('@@Bitte setzen Sie einen Status Key'));
                    } else {
                        errors.push(this.translate.instant('@@Bitte definieren Sie den Datei-Inhalt'));
                    }
                    break;
            }
        }
        if (errors.length > 0) {
            retVal.IsCorrect = false;
            retVal.Error = errors.join('\n');
        }
        return retVal;
    }

    getResult() {
        if (this.Data.ResourceType === ResourceType.Bytes) {
            this.Data.GetFromStatus = true;
        }
        return this.Data;
    }

    dataModelChanged() {
        this.Data.DataSource = null;
        this.loadDataSources();
    }

    loadDataSources() {
        this.DataSources = [];
        if (this.Data.DataModelID) {
            const query = new DataSourceQuery(this.Data.DataModelID);
            query.ResourceBase = 1; // Filebase
            this.service.GetDataSourcesByQuery(query).subscribe(x => {
                if (x) {
                    this.DataSources = x;
                }
            });
        }
    }

    onFileNameSelect(event) {
        if (event) {
            this.Data.FileName = event.Caption;
        }
    }
}

export class SaveResourceSettingsData {
    DataModelID: string;
    DataSource: string;
    FileName: string;
    GetFileNameFromStatus = false;
    ResourceType: ResourceType = ResourceType.Text;
    GetFromStatus = false;
    Value: string;
    Encoding: SaveResourceEncoding = SaveResourceEncoding.Default;
}

export enum ResourceType {
    Text,
    Bytes
}

// Mirrors backend enum SaveResourceEncoding (SaveResourceSettingsData.cs) by
// ordinal — never reorder, only append, and keep both sides in sync manually
// (this old frontend has no model generator).
export enum SaveResourceEncoding {
    Default,
    Utf8,
    Utf8Bom,
    Ansi,
    Ascii,
    Unicode
}

export class SaveResourceSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new SaveResourceSettingsData();
    }
}
